import type { App } from 'vue'
import type { MatterParameters } from './api'

export type UserModule = (app: App) => void | Promise<void>

export type AppEnvironment = 'development' | 'uat' | 'production' | 'local-development' | 'offline-development' | 'train'

export enum Role {
  Handler = 'Handler',
}

export type MatterInfo = Pick<MatterParameters, 'clientName' | 'weightmansReference' | 'clientReference' | 'matterDescription' | 'caseHandler' | 'insurerHandler' | 'dateInstructionsReceived' | 'dateOfAccident'>

export type MatterInfoKeys = (keyof MatterInfo)[]

export type PredictionParameters = Omit<MatterParameters, 'clientName' | 'weightmansReference' | 'clientReference' | 'matterDescription' | 'caseHandler' | 'insurerHandler' | 'dateInstructionsReceived' | 'dateOfAccident'>

export type PredictionParametersKeys = (keyof PredictionParameters)[]
